<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb/>
          </nav>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">

      <div class="row">
        <div class="col-lg-6">
          <div class="card-wrapper">
            <!-- Form controls -->
            <div class="card">
              <!-- Card body -->
              <div class="card-body">
                <form>
                  <base-input label="Campaña" placeholder="" v-model="validForm.campaingName" :error="(validForm.field.includes('campaingName') && validForm.campaingName=='') ? 'Invalido. Completar' : ''" />

                  <div class="row align-items-start">
                    <div class="col-md-3">
                      <base-radio v-model="radios.radio1"
                                  name="checked"
                                  class="mb-3 mb-md-5">
                                  Individual
                      </base-radio>
                    </div>
                      <div class="col-4 col-md-3">
                        <base-input disabled
                                    label=""
                                    v-model="validForm.CodePhoneContact"
                                    :error="(validForm.field.includes('CodePhoneContact')) ? 'Invalido. Completar' : ''"
                                    placeholder="+569" />
                      </div>
                      <div class="col-8 col-md-6">
                        <base-input type="number"
                                    v-model="validForm.PhoneContact"
                                    :error="(validForm.field.includes('PhoneContact') && validForm.PhoneContact=='') ? 'Invalido. Completar' : ''"
                                    :disabled="radios.radio1=='unchecked'"
                                    placeholder="12345678" />
                      </div>
                  </div>

                  <div class="row align-items-start">
                    <div class="col-md-3">
                      <base-radio v-model="radios.radio1"
                                  name="unchecked"
                                  class="mb-3">
                                  Lista
                       </base-radio>
                    </div>
                    <div class="col-md-9">
                      <base-input label="">
                        <el-select v-model="validForm.listContact"
                                   filterable
                                   :disabled="radios.radio1=='checked' || checkImportList==true"
                                   placeholder="Seleccionar lista existente"
                                   multiple
                                   >
                        <el-option v-for="option in selectOptionsListContact"
                                   :key="option.contactGroupId"
                                   :label="option.name"
                                   :value="option.contactGroupId">
                        </el-option>
                      </el-select>
                      <span class="small text-muted red-text"  v-if="(validForm.field.includes('listContact') && validForm.listContact=='')">Invalido . Completar</span>
                      </base-input>

                      <div class="custom-control custom-checkbox">
                        <input id="cbId"
                               class="custom-control-input"
                               type="checkbox"
                               :disabled="radios.radio1=='checked'"
                               v-model="checkImportList"/>
                        <label for="cbId" class="custom-control-label mb-3">
                          <slot>
                            <span>
                              Importar lista nueva
                            </span>
                          </slot>
                        </label>
                      </div>

                      <dropzone-file-upload v-model="fileSingle" v-show="showDropzone()" />

                      <div class="dropzone-disabled mb-3" v-show="!showDropzone()" >
                        <span class="mb-0 font-weight-400 text-muted">Arrastra tus archivos aquí...</span>
                      </div>



                      <base-progress  v-show="barProgreso>=1 && barProgreso<=99"  show-label type="success" :height="8" :value="barProgreso" label="Cargando Contactos"></base-progress>


                      <span v-show="checkImportList" v-for="list in listAnidadas"
                                     :key="list.id">
                        <br> &nbsp;&nbsp; *  <span class="font-weight-bolder">{{ list.contactos }}</span> contactos de la lista <span class="font-weight-bolder">{{ list.nombre }}</span>
                        </span>

                    </div>
                  </div>

                  <hr>

                  <label class="form-control-label">Mensaje</label>

                  <div class="row align-items-start">
                    <div class="col-md-6 d-flex">
                      <base-radio v-model="radios.redactar"
                                  name="checked"
                                  class="mb-3 mr-5">
                                  Redactar
                                  <el-tooltip content="Escribe el mensaje que quieres enviar, recuerda no usar acentos, caracteres especiales, etc..." placement="right">
                                    <i class="btn-tooltip text-gray fas fa-question-circle"></i>
                                  </el-tooltip>
                      </base-radio>
                    </div>
                    <div class="col-md-12">

                      <base-input label="" class="text-right">
                        <textarea class="form-control"
                                  :class="(validForm.field.includes('menssageContact') && validForm.menssageContact=='')?'border-red':''"
                                  v-model="validForm.menssageContact"
                                  id="exampleFormControlTextarea3"
                                  rows="3"
                                  maxlength="160"
                                  :disabled="radios.redactar=='unchecked'"
                                  placeholder="Escribir mensaje"></textarea>

                        <p class="small text-muted red-text"  v-if="(validForm.field.includes('menssageContact') && validForm.menssageContact=='')">Invalido . Completar</p>
                        <p class="small text-muted">Caracteres : {{validForm.menssageContact.length}}</p>
                      </base-input>
                    </div>

                    <div class="col-md-3">
                                 <span style="font-size: 14px">SMS Link</span>
                                  <el-tooltip content="Selecciona una landing previamente creada" placement="right">
                                    <i class="btn-tooltip text-gray fas fa-question-circle"></i>
                                  </el-tooltip>

                    </div>
                    <div class="col-md-9">
                      <base-input>

                        <el-select v-model="validForm.selectLanding"
                                   filterable
                                   placeholder="Seleccionar"
                                   :disabled="radios.redactar=='unchecked'"
                                   >
                          <el-option v-for="option in selectOptionsListLanding"
                                     :key="option.ladingId"
                                     :label="option.name"
                                     :value="option.link"
                                     >
                          </el-option>
                        </el-select>
                      </base-input>
                    </div>


                    <div class="col-md-3">
                      <base-radio v-model="radios.redactar"
                                  name="unchecked"
                                  class="mb-3">
                                  Plantillas
                                  <el-tooltip content="Selecciona una plantilla previamente creada que esté asociada a la lista de envio." placement="right">
                                    <i class="btn-tooltip text-gray fas fa-question-circle"></i>
                                  </el-tooltip>
                      </base-radio>
                    </div>
                    <div class="col-md-9">
                      <base-input>
                        <el-select v-model="validForm.selectDraft"
                                   filterable
                                   placeholder="Seleccionar"
                                   :disabled="radios.redactar=='checked' || radios.redactar=='unchecked_link'"
                                   multiple>
                          <el-option v-for="option in selectOptionsListDraftbyContactGroup"
                                     :key="option.draftId"
                                     :label="option.name"
                                     :value="option.draftId"
                                     >
                          </el-option>
                        </el-select>
                        <span class="small text-muted red-text"  v-if="(validForm.field.includes('selectDraft') && validForm.selectDraft=='')">Inválido. Completar</span>
                      </base-input>
                    </div>


                  </div>



                  <base-input label="" class="text-right" :disabled="radios.redactar=='checked'">
                    <card type="frame" v-for="option in previewDraft"
                                       :key="option.draftId">
                        <h2 style="text-align: left;">Plantilla : {{option.name}} ( {{option.contactGroup.name}} )</h2>
                       <p class="large text-left">{{option.message}}</p>
                    </card>
                  </base-input>

                  <hr>

                  <label class="form-control-label">Fecha del envío</label>

                  <div class="row align-items-start">
                    <div class="col-md-12 d-flex">
                      <base-radio v-model="radios.programacionEnvio"
                                  name="checked"
                                  class="mb-3 mr-5">
                                  Ahora
                      </base-radio>
                    </div>
                    <div class="col-md-3">
                      <base-radio v-model="radios.programacionEnvio"
                                  name="unchecked"
                                  class="mb-3">
                                  Programar
                      </base-radio>
                    </div>
                    <div class="col-md-9">
                      <base-input addon-left-icon="ni ni-calendar-grid-58" class="m-0">
                        <flat-picker slot-scope="{focus, blur}"
                                     @on-open="focus"
                                     @on-close="blur"
                                     :config="{allowInput: true,enableTime: true,}"
                                     class="form-control datepicker"
                                     placeholder="Elige fecha"
                                     :disabled="radios.programacionEnvio=='checked'"
                                     :class="(validForm.field.includes('dateProgramgContact') && validForm.dateProgramgContact=='')?'border-red':''"
                                     v-model="validForm.dateProgramgContact">
                        </flat-picker>
                      </base-input>
                      <span class="small text-muted red-text posicion-absoluta"  v-if="(validForm.field.includes('dateProgramgContact') && validForm.dateProgramgContact=='')">Invalido . Completar</span>
                    </div>
                  </div>

                <base-button type="celcomblue" :disabled="barProgreso>=1 && barProgreso<=99" v-if="radios.radio1=='checked'" @click="envioSimple" class="mt-4 d-block ml-auto">
                  Siguiente
                </base-button>

                <base-button type="celcomblue" :disabled="barProgreso>=1 && barProgreso<=99" v-else @click="envioMasivo(0,false,0)" class="mt-4 d-block ml-auto">
                  Siguiente
                </base-button>

                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="card-wrapper">
            <!-- Sizes -->
            <div class="card " :class="(validForm.StepPreview) ? '' : 'disabled'">
              <!-- Card body -->
              <div class="card-header bg-transparent">
                <h3>Confirmación del envío</h3>
              </div>
              <div class="card-body">

                <p class="text-dark" v-if="radios.radio1=='checked' && this.validForm.PhoneContact !='' ">El nombre del envío es <span class="font-weight-bolder">{{ (validForm.StepPreview) ? validForm.campaingName:'" "' }}</span>. Se enviará al <span class="font-weight-bolder">{{this.validForm.PhoneContact }}</span> el día <span class="font-weight-bolder">{{ (validForm.StepPreview) ? this.validForm.dateSend:'" "' }}</span> .</p>


                <p class="text-dark" v-if="radios.radio1=='unchecked' &&
                 this.listAnidadas.length <= 1 && !checkImportList || radios.radio1=='unchecked' && checkImportList && this.listAnidadas.length <= 1 ">El nombre del envío es <span class="font-weight-bolder">{{ (validForm.StepPreview) ? validForm.campaingName:'" "' }}</span>. Se enviará a <span class="font-weight-bolder">{{( this.validForm.sendingTotal > 0) ? this.validForm.sendingTotal : '1' }}</span> contactos de la lista <span class="font-weight-bolder">{{ this.nameContactList }}</span> el día <span class="font-weight-bolder">{{ (validForm.StepPreview) ? this.validForm.dateSend:'" "' }}</span> .</p>



                <p class="text-dark" v-if="this.listAnidadas.length > 1 && radios.radio1=='unchecked'">El nombre del envío es <span class="font-weight-bolder">{{ (validForm.StepPreview) ? validForm.campaingName:'" "' }}</span>. Se enviará a :

               <span v-for="list in listAnidadas"
                                     :key="list.id">
                 <br> &nbsp;&nbsp; *  <span class="font-weight-bolder">{{ list.contactos }}</span> contactos de la lista <span class="font-weight-bolder">{{ list.nombre }}</span>
                </span>
                  <br>
                 el día <span class="font-weight-bolder">{{ (validForm.StepPreview) ? this.validForm.dateSend:'" "' }}</span> .</p>




                <label class="form-control-label">Vista previa del envío</label>
                <p class="small">Se muestra un ejemplo de 10 números.</p>

                <el-table class="table-responsive table-flush table-fixed"
                          header-row-class-name="thead-light"
                          :data="previewSend">
                    <el-table-column label="Número"
                                    prop="phone"
                                    min-width="140px"
                                    sortable>
                                     <div slot-scope="{row}">
                                      {{ row.phoneCode+" "+row.phone }}
                                    </div>
                    </el-table-column>
                    <el-table-column label="Mensaje"
                                    prop="message"
                                    min-width="250px"
                                    sortable>
                    </el-table-column>
                    <el-table-column label="Caracteres"
                                    prop="message"
                                    min-width="150px"
                                    sortable>
                                     <div slot-scope="{row}">
                                      {{ row.message.length }}
                                    </div>
                    </el-table-column>
                </el-table>

                <base-button @click="envioServices" type="celcompink" :disabled="(!validForm.StepPreview)" class="mt-4 d-block ml-auto">
                  <i class="fas fa-paper-plane"></i> Enviar
                </base-button>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.dropzone-disabled {
  text-align: center;
  background-color: #fff;
  border: 1px dashed #dee2e6;
  border-radius: 0.375rem;
  background-color: #e9ecef;
  cursor: not-allowed;
  padding: 2.25rem 1rem;
}
.dz-message {
  padding: 2.25rem 1rem;
}
.card {
  &.disabled {
    background: #e9ecef;
    .card-body {
      opacity: .5;
    }
  }
}
.busy-mask {
  z-index: 1051;
}
</style>

<script>
  import FileInput from '@/components/Inputs/FileInput'
  import DropzoneFileUpload from '@/components/Inputs/DropzoneFileUpload'
  import { BasePagination, Modal, Dialog } from '@/components';

  import { Spanish } from "flatpickr/dist/l10n/es.js"
  flatpickr.localize(Spanish);
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import XLSX from 'xlsx';

  import { Select, Option, Table, TableColumn, DropdownMenu, DropdownItem, Dropdown } from 'element-ui'
  import moment from 'moment';

  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  import AES256 from 'aes-everywhere';
  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import Config from '@/config/config.js'
  import { getUser, setUser, encryptAES, horaAhora,getUserRealTime,removeElement,removeSpecialChars,getUserSub } from '@/util/util.js';

  Vue.use(VueAxios, axios)
  Vue.use(Dialog)

  export default {
    name: 'NuevoEnvio',
    components: {
      FileInput,
      [Select.name]: Select,
      [Option.name]: Option,
      DropzoneFileUpload,
      flatPicker,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      Modal,
      Dialog
    },
    data() {
      return {
        fileSingle: [],
        inputs: {
          file: []
        },
        checkboxes: {
          unchecked: false,
          checked: true,
          uncheckedDisabled: false,
          checkedDisabled: true
        },
        radios: {
          radio1: 'checked',
          radio2: 'checked',
          redactar: 'checked',
          programacionEnvio: 'checked',
        },
        selectOptionsListContact: [],
        selectOptionsListDraft: [],
        selectOptionsListDraftbyContactGroup: [],
        selectOptionsListLanding: [],
        selects: {
          listas: 'Seleccione',
          mensajes: 'Seleccione',
          multiple: ['Alerts', 'Buttons']
        },
        dates: {
          range: "2019-09-17 to 2019-09-19"
        },
        previewSend: [
          {
            phoneCode:"569",
            phone: "12345678",
            message: "Mensaje de prueba",
          }
        ],
        checkChildrenId:true,
        checkImportList:false,
        checkEnvioProgramado:true,
        contadorListImportadas:0,
        contadorContactImportados:0,
        contadorMultipleContactList:[],
        contadorMultipleContactListCurrent:0,
        sendingInfoEdit:{},
        nameContactList:"",
        previewDraft:[],
        listAnidadas:[],
        mostrarAlertEnvio:false,
        totalCreditosUsar:0,
        barProgreso:0,
        validForm:{
            estado:false,
            field:"",
            campaingName:"",
            CodePhoneContact:getUser().customer.country.phoneCode,
            PhoneContact:"",
            listContact:[],
            dateProgramgContact:"",
            menssageContact:"",
            selectDraft:[],
            selectLanding:[],
            StepPreview:false,
            dateSend:"",
            sendingsms:"",
            contacts:[],
            childrenId:null,
            sendingTotal:0,
            sendingsmsId:null,
            sendingUDH:[],
            position:0,
        }
      }
    },
    watch:{

    /**
     * IMPORTAR LISTA DESDE EXCEL
     */
     'fileSingle'(e){

        var self = this;

        self.barProgreso=4;

       // self.$loading.show()

        var files = e, f = files[(files.length-1)];
        var reader = new FileReader();-1
        reader.onload = function(e) {
          var data = new Uint8Array(e.target.result);
          var workbook = XLSX.read(data, {type: 'array'});

          var first_worksheet = workbook.Sheets[workbook.SheetNames[0]];
          var data = XLSX.utils.sheet_to_json(first_worksheet, {header:1});

         // console.log("datos importados : ",data);


         let user = (getUserSub()!=null) ? getUserSub() :getUser();


          let header = "";
          let dataTotal = [];

          var cheader = 0;
          //crea header
          if(data.length > 0){


              //SE ACTIVA LECTURA DE EXCEL DE ABERTIS
            if(user.customer.customerId==210 || user.customer.customerId==209 || user.customer.customerId==219){

                  header="###idsmmcc###|*#*idms2*#*";

                  //LIMPIO LA DATA POR ESPACIOS EN BLANCO O DATOS INVALIDOS
                  data.forEach(function(key){

                  var phone = "";
                  var phoneCode = "569";
                  var field = "";
                          phone=key[3];
                          field+=(key[2])+"|";
                          field+=(key[0])+"|";
                        //VALIDA QUE SEA SOLO NUMERO
                      if (phone!="" && /^([0-9])*$/.test(phone) && /^([0-9])*$/.test(phoneCode)  && phone.toString().length > 7  ){
                        // console.log("subir : "+phoneCode)
                        if (phone.toString().length > 8  ){
                              key[3]  = phone.toString().substring((phone.toString().length-8), phone.toString().length);
                        }
                        dataTotal.push(key);
                      }
                });

            }else{

            data[0].forEach(function(key){
              cheader++;
              if(cheader>2){
                  header+=key+"|";
              }
            });



          //LIMPIO LA DATA POR ESPACIOS EN BLANCO O DATOS INVALIDOS
          data.forEach(function(key){

           var phone = "";
           var phoneCode = "";
           var field = "";
              for(var j = 0 ; j < key.length ; j++){

                    if(j == 0){
                        phoneCode=key[j];
                    }
                    if(j == 1){
                        phone=key[j];
                    }
                    if(j > 1){
                        field+=(key[j])+"|";
                    }
                }
                //VALIDA QUE SEA SOLO NUMERO
               if (phone!="" && /^([0-9])*$/.test(phone) && /^([0-9])*$/.test(phoneCode)  && phone.toString().length > 7  ){
                // console.log("subir : "+phoneCode)
                if (phone.toString().length > 8  ){
                    key[1]  = phone.toString().substring((phone.toString().length-8), phone.toString().length);
                }
                dataTotal.push(key);
               }
        });

            }

          }

       if( (self.contadorContactImportados+dataTotal.length) > 20000 && user.customer.uploadActive==false){
            swal({
                  title: "Error limite de contactos excedidos (20.000)",
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger btn-fill'
                })
            self.barProgreso=0;

                return false;
        }

        console.log("datos importados header : ",header);

        self.guardarNuevaLista(header,files[(files.length-1)].name.substr(0,180),dataTotal);


        };
        reader.readAsArrayBuffer(f);

     },

    'validForm.selectDraft'(newVal){
      let self = this;
      self.previewDraft = [];
        //BUSCA NOMBRE DE DRAFT SELECCIONADA
        this.selectOptionsListDraftbyContactGroup.forEach(function(key) {
          self.validForm.selectDraft.forEach(function(key2) {
            if (key.draftId == key2) {
              self.previewDraft.push(key);
            }
        });
      });
    },

    'validForm.selectLanding'(newVal){
      let self = this;
      self.validForm.menssageContact+=" "+newVal;
    },

    'validForm.listContact'(newVal){

      let self = this;

      if(!self.checkImportList){

          self.listAnidadas=[];
          self.contadorMultipleContactList=[];
          self.contadorMultipleContactListCurrent=0;
          self.selectOptionsListDraftbyContactGroup=[];
          self.totalCreditosUsar=0;

              if(newVal.length >= 1){
              newVal.forEach(function(key) {
                self.selectOptionsListContact.forEach(function(key2) {
                    if (key2.contactGroupId == key) {

                      self.selectOptionsListDraft.forEach(function(draft) {
                            if(draft.contactGroup.contactGroupId==key2.contactGroupId ||  draft.master){

                                if(self.selectOptionsListDraftbyContactGroup.indexOf(draft)==-1){
                                  self.selectOptionsListDraftbyContactGroup.push(draft)
                                }
                            }
                      });

                      //self.contadorListImportadas+=1;
                          self.listAnidadas.push({
                          "id":key2.contactGroupId,
                          "nombre":key2.name,
                          "contactos":(key2.validos+key2.invalidos)
                        })

                        self.totalCreditosUsar += (key2.validos+key2.invalidos);

                        self.contadorMultipleContactList.push(key2.contactGroupId)
                        self.contadorMultipleContactListCurrent++;


                    }
              });
        });
            }
      }else{

          if(newVal.length >= 1){
              newVal.forEach(function(key) {
                self.selectOptionsListContact.forEach(function(key2) {
                    if (key2.contactGroupId == key) {
                      self.selectOptionsListDraft.forEach(function(draft) {
                            if(draft.contactGroup.contactGroupId==key2.contactGroupId ||  draft.master){

                                if(self.selectOptionsListDraftbyContactGroup.indexOf(draft)==-1){
                                  self.selectOptionsListDraftbyContactGroup.push(draft)
                                }
                            }
                      });




                    }
              });
        });
            }

      }



    }

    },
    methods: {


      /**
       * CREAR NUEVA LISTA DE CONTACTOS
       */
      async createListContact(contactGroup,contacts,user,interation,current,total_contacts){


        var self = this;
         //LOGICA QUE CREA ARRAY DE CONTACTOS
        let nuevoContacto = [];
        var c=0;



           //SE ACTIVA LECTURA DE EXCEL DE ABERTIS
            if(user.customer.customerId==210 || user.customer.customerId==209 || user.customer.customerId==219){

                  contacts.forEach(function(key){

                    var phone = "";
                    var phoneCode = "569";
                    var field = "";
                          phone=key[3];
                          field+=(key[2])+"|";
                          field+=(key[0])+"|";

                          //VALIDA QUE SEA SOLO NUMERO
                        if (phone!="" && /^([0-9])*$/.test(phone) && /^([0-9])*$/.test(phoneCode)  && phone.toString().length > 7  ){
                          nuevoContacto.push({
                                "phoneCode": (phoneCode),
                                "phone": (phone),
                                //"contactGroup": contactGroup,
                                "field": field,
                                "status": true,
                                "selected": false
                          });
                          self.contadorContactImportados+=1;

                        }

                      //}
                      c++;

                  });




            }else{


                 contacts.forEach(function(key){

                    var phone = "";
                    var phoneCode = "";
                    var field = "";
                      //if(c > 0){
                        for(var j = 0 ; j < key.length ; j++){

                              if(j == 0){
                                  phoneCode=key[j];
                              }
                              if(j == 1){
                                  phone=key[j];
                              }
                              if(j > 1){
                                  field+=(key[j])+"|";
                              }
                          }
                          //VALIDA QUE SEA SOLO NUMERO
                        if (phone!="" && /^([0-9])*$/.test(phone) && /^([0-9])*$/.test(phoneCode)  && phone.toString().length > 7  ){
                          nuevoContacto.push({
                                "phoneCode": (phoneCode),
                                "phone": (phone),
                                //"contactGroup": contactGroup,
                                "field": field,
                                "status": true,
                                "selected": false
                          });
                          self.contadorContactImportados+=1;

                        }

                      //}
                      c++;

                  });


            }






        let js = {
          "time_expired":horaAhora(),
          "contact_group":encodeURIComponent(JSON.stringify(contactGroup)),
          "contact":encodeURIComponent(JSON.stringify(nuevoContacto)),
          "customer":encodeURIComponent(JSON.stringify(user.customer)),
        }

        var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

        await Vue.axios.post(Config.url_service+Config.contact_add_contacts, body, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        })
          .then(async function (response) {

              console.log(response)

              if (response.data.response === "200") {

             //   console.log("contactos importados : ",response.data.data);


                console.log("slice nueva iteration  : ",interation[current]);


                //SI ESTA INDEFINIDAD LA LISTA ES MENOR A 4000 Y NO HACE RECURSIVIDAD
                if(interation.length >= 1){

                  let promedioProgreso = total_contacts.length/((Math.ceil(total_contacts.length/4000)));

                  console.log(" progresoBar  ",Number((promedioProgreso * current)*100/total_contacts.length ).toFixed(0) )

                  self.barProgreso=parseInt(Number((promedioProgreso * current)*100/total_contacts.length ).toFixed(0));

                  if(self.barProgreso>=99){
                    self.$loading.show()
                  }

                  console.log(" iteraction  ",interation)

                //VALIDA QUE TODOS LOS CONTACTOS SE IMPORTARAN Y TERMINA RECURSIVIDAD
                if(interation[current].i >= (total_contacts.length+4000)){

                     await self.loadGroupContact();

                    self.validForm.listContact.push(contactGroup.contactGroupId);

                    /*if(self.checkChildrenId){
                      self.validForm.listContact.push(contactGroup.contactGroupId);
                      self.validForm.childrenId = contactGroup.contactGroupId;
                    }*/

                    self.$loading.hide()

                    self.contadorListImportadas+=1;

                     self.listAnidadas.push({
                          "id":contactGroup.contactGroupId,
                          "nombre":contactGroup.name,
                          "contactos":total_contacts.length
                    })

                    self.contadorMultipleContactList.push(contactGroup.contactGroupId)
                    self.contadorMultipleContactListCurrent++;

                    swal({
                      title: "Contactos Cargados",
                      buttonsStyling: false,
                      confirmButtonClass: 'btn btn-success btn-fill'
                    })

                }else{
                    //FUNCION RECURSIVA DE IMPORTAR CONTACTOS
                   await self.createListContact(contactGroup,total_contacts.slice(interation[current].init,interation[current].i),user,interation,(current+1),total_contacts);

                }

                }else{

                    await self.loadGroupContact();

                    self.validForm.listContact.push(contactGroup.contactGroupId);

                   /* if(self.checkChildrenId){
                    self.validForm.listContact.push(contactGroup.contactGroupId);
                      self.validForm.childrenId = contactGroup.contactGroupId;
                    }*/

                    self.$loading.hide()

                    self.listAnidadas.push({
                          "id":contactGroup.contactGroupId,
                          "nombre":contactGroup.name,
                          "contactos":total_contacts.length
                    })
                    self.contadorMultipleContactList.push(contactGroup.contactGroupId)
                    self.contadorMultipleContactListCurrent++;

                    self.contadorListImportadas+=1;

                    swal({
                      title: "Contactos Cargados",
                      buttonsStyling: false,
                      confirmButtonClass: 'btn btn-success btn-fill'
                    })

                }

              } else {
                console.log("No se pudo crear contacto");
                self.$loading.hide()
                swal({
                  title: "Error no se pudo crear contacto",
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger btn-fill'
                })
              }

          })

      },

    /**
     * CREA NUEVA LISTA DE CONTACTOS
     */
      async guardarNuevaLista(header,name,contacts) {

        let self = this;
         let user = (getUserSub()!=null) ? getUserSub() :getUser();

        let nuevaLista = {
          "customerId": user.customer.customerId,
          "name": name,
          "header": header,
          "active":true,
          "validos": "0",
          "invalidos": "0",
         // "childrenId":(this.checkChildrenId) ? this.validForm.childrenId : ""
          "childrenId":""
        }


        let js = {
          "time_expired":horaAhora(),
          "contact_group":encodeURIComponent(JSON.stringify(nuevaLista)),
          "customer":encodeURIComponent(JSON.stringify(user.customer)),
        }

        var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

        await Vue.axios.post(Config.url_service+Config.contact_add_contact_group, body, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        })
          .then(function (response) {

              console.log("ContactGroup creado ",response)

              if (response.data.response === "200") {

                self.totalCreditosUsar += contacts.length;

                //PERAPARA CANTIDAD DE INTERACCIONES
                  var i=4000;var init =1;var interation = [];
                  contacts.forEach(function(key){
                    if ( i % 4000 == 0 ) {

                      console.log("slice  : "+init+" "+i);

                      interation.push({'init':(init+1),'i':i})

                        init = i;
                    }
                    i++;
                  })

                  interation.push({'init':contacts.length,'i':(contacts.length+4000)})

                 self.createListContact(response.data.data,contacts.slice(0,4000),user,interation,1,contacts)

              } else {
                console.log("No se pudo crear lista");

                swal({
                  title: "Error no se pudo crear lista",
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger btn-fill'
                })
              }
          })
      },
      /**
       * CARGAR LISTA DE GRUPOS DE CONTACTOS
       */
     async loadGroupContact(){

      let self = this;
       let user = (getUserSub()!=null) ? getUserSub() :getUser();

      let js = {
        "time_expired":horaAhora(),
        "customer":encodeURIComponent(JSON.stringify(user.customer))
      }

      var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

     await Vue.axios.post(Config.url_service+Config.contact_available, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      })
        .then(function (response) {
            console.log(response)

            if (response.data.response === "200") {

              self.selectOptionsListContact = response.data.data;

            } else {
              console.log("No se encontró lista de contacto");
            }


        })
        .catch(function (error) {
            console.log("No se encontró lista",error);
        });

      },
      /**
       * CARGAR LISTA DE BORRADORES
       */
      loadDraft(){

      let self = this;
       let user = (getUserSub()!=null) ? getUserSub() :getUser();

      let js = {
        "time_expired":horaAhora(),
        "customer":encodeURIComponent(JSON.stringify(user.customer))
      }

      var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

      Vue.axios.post(Config.url_service+Config.draft_available, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      })
        .then(function (response) {
            console.log(response)

            if (response.data.response === "200") {

              self.selectOptionsListDraft = response.data.data;

            } else {
              console.log("No se encontró lista de borradores");
            }


        })
        .catch(function (error) {
            console.log("No se encontró lista",error);
        });

      },
      /**
       * CARGAR LISTA DE LANDING
       */
      loadLanding(){

      let self = this;
       let user = (getUserSub()!=null) ? getUserSub() :getUser();

      let js = {
        "time_expired":horaAhora(),
        "customer_user":encodeURIComponent(JSON.stringify(user))
      }

      var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

      Vue.axios.post(Config.url_service+Config.landing_available, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      })
        .then(function (response) {
            console.log(response)

            if (response.data.response === "200") {

              self.selectOptionsListLanding = response.data.data;

            } else {
              console.log("No se encontró lista de landing");
            }


        })
        .catch(function (error) {
            console.log("No se encontró lista landing ",error);
        });

      },

      /**
       * Metodo de Envio individual
       */
      async envioSimple(){


        this.$loading.show()

        let self = this;
        let user = await getUserRealTime();


        self.mostrarAlertEnvio = false;

        this.validForm.estado=false;

        if(this.validForm.campaingName == ""){
          this.validForm.field+=",campaingName"; this.validForm.estado=true;
        }
        if(this.validForm.CodePhoneContact == "" || this.validForm.CodePhoneContact != user.customer.country.phoneCode){
          this.validForm.field+=",CodePhoneContact"; this.validForm.estado=true;
        }
        if(this.validForm.PhoneContact == ""){
          this.validForm.field+=",PhoneContact"; this.validForm.estado=true;
        }
        if(this.validForm.menssageContact == ""  && this.radios.redactar=='checked'){
          this.validForm.field+=",menssageContact"; this.validForm.estado=true;
        }
        if(this.validForm.dateProgramgContact == "" && this.radios.programacionEnvio=='unchecked'){
          this.validForm.field+=",dateProgramgContact"; this.validForm.estado=true;
        }
        if(this.validForm.selectDraft == "" && this.radios.redactar=='unchecked'){
          this.validForm.field+=",selectDraft"; this.validForm.estado=true;
        }

        if(this.validForm.field.length > 0 && this.validForm.estado){

          this.$loading.hide()

          return false;

        }

        var currentDate = new Date();
        currentDate = new Date(currentDate).getTime();

          if(this.radios.programacionEnvio=='unchecked'){
            var currentDate2 = new Date();
            currentDate2 = new Date(this.validForm.dateProgramgContact).getTime();
          }

        moment.locale('es');
        this.validForm.dateSend = (this.radios.programacionEnvio=='checked') ? moment(currentDate).format('LLL') : moment(currentDate2).format('LLL');


        self.totalCreditosUsar=1;

        this.validForm.sendingsms = {
          "customerId":user.customer.customerId,
          "sendingSmsId":this.validForm.SendingSmsId,
          "name": (typeof this.$route.query.sending_sms!=="undefined") ? self.validForm.campaingName : self.validForm.campaingName+" "+self.nameContactList,
          "receiverType":1,
          "phoneCode":this.validForm.CodePhoneContact,
          "phone":this.validForm.PhoneContact,
          "draftId":(this.radios.redactar=='unchecked') ?  this.validForm.selectDraft : 0,
          "messageType":(this.radios.redactar=='checked') ? 1 : 2,
          "message":this.validForm.menssageContact ,
          "calendarType":(this.radios.programacionEnvio=='checked') ? 1 : 2,
          "calendar":(this.radios.programacionEnvio=='checked') ? currentDate:currentDate2,
          "createdby":user.customerUserId,
          "created":currentDate,
          "aborted":false,
          "sendingSmsDetailList":[
              {
                "sendingSmsDetailId":0,
                "customerId":user.customer.customerId,
                "name":this.validForm.campaingName,
                "phoneCode":this.validForm.CodePhoneContact,
                "phone":this.validForm.PhoneContact,
                "message":this.validForm.menssageContact ,
                "operatorId":0,
                "blacklistUser":false,
                "udh":true
              }
          ],
          "sendingStatus":(typeof this.$route.query.sending_sms!=="undefined") ? "0":"1",
          "sendingTotal":1,
          "sendingPosition":1
        }

        let js = {
        "time_expired":horaAhora(),
        "children_active":(this.contadorListImportadas >= 2) ? "false" : "false",
        "customer":encodeURIComponent(JSON.stringify(user.customer)),
        "sending_sms":encodeURIComponent(JSON.stringify(this.validForm.sendingsms))
      }

            console.log("aquiii ",js)


      var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

      Vue.axios.post(Config.url_service+Config.sending_sms_create_edit, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      })
        .then(function (response) {
            console.log(response)

            self.validForm.StepPreview = false;

            if (response.data.response === "200" && ( response.data.data.sendingStatus=="1"
            || response.data.data.sendingStatus=="0") ) {

              self.previewSend = response.data.data.sendingSmsDetailList;
              self.validForm.sendingsms = response.data.data
              self.validForm.SendingSmsId = response.data.data.sendingSmsId

              self.validForm.StepPreview = true;

            }else if (response.data.data.sendingStatus=="3") {

              swal({
                  title: "Error creditos insuficientes",
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger btn-fill'
                })

            }else if (response.data.data.sendingStatus=="2") {

              swal({
                  title: "Error hora de envio invalido. Intente mas tarde",
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger btn-fill'
                })

            }else if (response.data.message=="PRIMER ENVIO") {

              swal({
                  title: "Debe esperar que se apruebe su cuenta para poder hacer envios",
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger btn-fill'
                })

            }else if (response.data.message=="ERROR PALABRA BLOQUEADA") {

              swal({
                  title: "Error el texto del mensaje contiene palabras bloqueadas",
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger btn-fill'
                })

            } else {
              console.log("No se encontró preview");
              swal({
                  title: "Error al procesar mensaje",
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger btn-fill'
                })
            }

          self.$loading.hide()

        })
        .catch(function (error) {
            console.log("No se encontró preview",error);
            swal({
                  title: "Error al procesar mensaje",
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger btn-fill'
                })
            self.$loading.hide()

        });



      },
/**
       * Metodo de Envio individual
       */
      async envioMasivo(currentIndexContactListPar,activarService,position){

        position++;

        var currentIndexContactList = currentIndexContactListPar;

          if(currentIndexContactList <= 0){
             currentIndexContactList = this.contadorMultipleContactList[0];
          }


        this.$loading.show()

        let self = this;
        let user = await getUserRealTime();


        if(self.totalCreditosUsar > user.remainingSms && user.customer.monthlyLimit && !user.customer.postpaid){

                swal({
                  title: "Error creditos insuficientes",
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger btn-fill'
              })
              this.$loading.hide()
              return false;

        }

        self.mostrarAlertEnvio = activarService;


        var cList=0
        var cListValid = false;
      /*  self.listAnidadas.forEach(function(key) {
              cList = cList+key.contactos;
              if( cList > 40000 ){
                  cListValid = true;
              }
          })

          if(cListValid){
              swal({
                title: "Error limite de contactos excedidos",
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger btn-fill'
              })
            this.$loading.hide()
            return false;
        }*/

        this.validForm.estado=false;

        if(this.validForm.campaingName == ""){
          this.validForm.field+=",campaingName"; this.validForm.estado=true;
        }
        if(this.validForm.listContact == ""){
          this.validForm.field+=",listContact"; this.validForm.estado=true;
        }
        if(this.validForm.menssageContact == ""  && this.radios.redactar=='checked'){
          this.validForm.field+=",menssageContact"; this.validForm.estado=true;
        }
        if(this.validForm.dateProgramgContact == "" && this.radios.programacionEnvio=='unchecked'){
          this.validForm.field+=",dateProgramgContact"; this.validForm.estado=true;
        }
        if( (this.validForm.selectDraft == "" || this.validForm.selectDraft.length <= 0 )
          && this.radios.redactar=='unchecked'){
          this.validForm.field+=",selectDraft"; this.validForm.estado=true;
        }

        if(this.validForm.field.length > 0 && this.validForm.estado){

          this.$loading.hide()

          return false;

        }


      await this.getContactGroupPreview(currentIndexContactListPar,activarService);

      var currentDate = new Date();
      currentDate = new Date(currentDate).getTime();

        if(this.radios.programacionEnvio=='unchecked'){
          var currentDate2 = new Date();
          currentDate2 = new Date(this.validForm.dateProgramgContact).getTime();
        }

        var NombreListaContacto = "";

        //BUSCA NOMBRE DE LISTA SELECCIONADA
        this.listAnidadas.forEach(function(key) {
        if (key.id == currentIndexContactList) {
          self.nameContactList = key.nombre;
          self.validForm.sendingTotal = key.contactos;
          NombreListaContacto = key.nombre;
        }
        });



        moment.locale('es');
        this.validForm.dateSend = (this.radios.programacionEnvio=='checked') ? moment(currentDate).format('LLL') : moment(currentDate2).format('LLL');

          if(user.customer.concatenateMessage){

              await this.getUdhCredits(currentIndexContactListPar,activarService,currentDate,currentDate2);

          }

        self.validForm.sendingsms = {
          "customerId":user.customer.customerId,
          "sendingSmsId":self.validForm.SendingSmsId,
          "name": (typeof this.$route.query.sending_sms!=="undefined") ? self.validForm.campaingName : self.validForm.campaingName+" "+NombreListaContacto,
          "receiverType":2,
          "receiverId":(activarService) ? self.validForm.listContact[self.validForm.listContact.indexOf(currentIndexContactList)] :self.validForm.listContact[0],
          "phoneCode":self.validForm.CodePhoneContact,
          "phone":0,
          "draftId":(self.radios.redactar=='unchecked') ?  self.getDraftByContactGroup((activarService) ? self.validForm.listContact[self.validForm.listContact.indexOf(currentIndexContactList)] :self.validForm.listContact[0]) : 0,
          "messageType":(self.radios.redactar=='checked') ? 1 : 2,
          "message":self.validForm.menssageContact ,
          "calendarType":(self.radios.programacionEnvio=='checked') ? 1 : 2,
          "calendar":(self.radios.programacionEnvio=='checked') ? currentDate:currentDate2,
          "createdby":user.customerUserId,
          "created":currentDate,
          "aborted":false,
          "sendingSmsDetailList":(self.validForm.contacts.length >= 10) ? self.validForm.contacts.slice(0,9) : self.validForm.contacts,
          "sendingStatus":(typeof this.$route.query.sending_sms!=="undefined") ? "0":"1",
          "sendingTotal":(self.validForm.sendingUDH.length > 0) ? self.getTotalSendingUdh((activarService) ? self.validForm.listContact[self.validForm.listContact.indexOf(currentIndexContactList)] :self.validForm.listContact[0]): self.validForm.sendingTotal,
          "sendingPosition":position
        }



        let js = {
        "time_expired":horaAhora(),
        "children_active":(self.contadorListImportadas >= 2) ? "false" : "false",
        "customer":encodeURIComponent(JSON.stringify(user.customer)),
        "sending_sms":encodeURIComponent(JSON.stringify(self.validForm.sendingsms))
      }


      var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

     await Vue.axios.post(Config.url_service+Config.sending_sms_create_edit, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      })
        .then(async function (response) {
            console.log(response)

            self.validForm.StepPreview = false;

            if (response.data.response === "200" && ( response.data.data.sendingStatus=="1"
            || response.data.data.sendingStatus=="0") ) {

              self.previewSend = response.data.data.sendingSmsDetailList;
              self.validForm.sendingsms = response.data.data
              self.validForm.SendingSmsId = response.data.data.sendingSmsId
              self.validForm.sendingTotal = response.data.data.sendingTotal
              self.validForm.StepPreview = true;


              ///ACTUALIZAR DATOS DEL SENDING SMS
              var sending_sms_recursivo = {
                  "customerId":user.customer.customerId,
                  "sendingSmsId":response.data.data.sendingSmsId,
                  "name": (typeof self.$route.query.sending_sms!=="undefined") ? self.validForm.campaingName : self.validForm.campaingName+" "+NombreListaContacto,
                  "receiverType":2,
                  "receiverId":(activarService) ? self.validForm.listContact[self.validForm.listContact.indexOf(currentIndexContactList)] :self.validForm.listContact[0],
                  "phoneCode":self.validForm.CodePhoneContact,
                  "phone":0,
                  "draftId":(self.radios.redactar=='unchecked') ?  self.getDraftByContactGroup((activarService) ? self.validForm.listContact[self.validForm.listContact.indexOf(currentIndexContactList)] :self.validForm.listContact[0]) : 0,
                  "messageType":(self.radios.redactar=='checked') ? 1 : 2,
                  "message":self.validForm.menssageContact ,
                  "calendarType":(self.radios.programacionEnvio=='checked') ? 1 : 2,
                  "calendar":(self.radios.programacionEnvio=='checked') ? currentDate:currentDate2,
                  "createdby":user.customerUserId,
                  "created":currentDate,
                  "aborted":false,
                  "sendingSmsDetailList":(self.validForm.contacts.length >= 10) ? self.validForm.contacts.slice(0,9) : self.validForm.contacts,
                  "sendingStatus":(typeof self.$route.query.sending_sms!=="undefined") ? "0":"1",
                  "sendingTotal":(self.validForm.sendingUDH.length > 0) ? self.getTotalSendingUdh((activarService) ? self.validForm.listContact[self.validForm.listContact.indexOf(currentIndexContactList)] :self.validForm.listContact[0]):self.validForm.sendingTotal,
                  "sendingPosition":position
                }



              //SOLO SI SE USA SELECCION MULTIPLE SE ACTIVA LA RECURSIVIDAD DE LISTAS DE CONTACTOS
              if(activarService){

                 await self.envioServices(sending_sms_recursivo,position);

                  return false;

              }

            }else if (response.data.data.sendingStatus=="3") {

                swal({
                  title: "Error creditos insuficientes",
                  text: (activarService) ? 'Ocurrio un error enviando la lista '+self.nameContactList+' Revisar en Reportes las campañas enviadas y reenviela nuevamente':"",
                  type: 'error',
                  showCancelButton: false,
                  confirmButtonColor: '#f53636',
                  confirmButtonText: 'OK'
                }).then(function() {
                  if(activarService){
                      window.location.href="/reportes/reporte-mt";
                  }
                })

            }else if (response.data.data.sendingStatus=="2") {

                 swal({
                  title: "Error hora de envio invalido. Intente mas tarde",
                  text: (activarService) ? 'Ocurrio un error enviando la lista '+self.nameContactList+' Revisar en Reportes las campañas enviadas y reenviela nuevamente':"",
                  type: 'error',
                  showCancelButton: false,
                  confirmButtonColor: '#f53636',
                  confirmButtonText: 'OK'
                }).then(function() {
                  if(activarService){
                      window.location.href="/reportes/reporte-mt";
                  }
                })

            }else if (response.data.message=="ERROR PALABRA BLOQUEADA") {

              swal({
                  title: "Error el texto del mensaje contiene palabras bloqueadas",
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger btn-fill'
                })

            } else if (response.data.message=="PRIMER ENVIO") {

              swal({
                  title: "Debe esperar que se apruebe su cuenta para poder hacer envios",
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger btn-fill'
                })

            } else {
              console.log("No se encontró preview");

              swal({
                  title: "Error al procesar mensaje",
                  text: (activarService) ? 'Ocurrio un error enviando la lista '+self.nameContactList+' Revisar en Reportes las campañas enviadas y reenviela nuevamente':"",
                  type: 'error',
                  showCancelButton: false,
                  confirmButtonColor: '#f53636',
                  confirmButtonText: 'OK'
                }).then(function() {
                  if(activarService){
                      window.location.href="/reportes/reporte-mt";
                  }
                })


            }
          self.$loading.hide()

        })
        .catch(function (error) {
            console.log("No se encontró preview",error);


             swal({
                  title: "Error al procesar mensaje",
                  text: (activarService) ? 'Ocurrio un error enviando la lista '+self.nameContactList+' Revisar en Reportes las campañas enviadas y reenviela nuevamente':"",
                  type: 'error',
                  showCancelButton: false,
                  confirmButtonColor: '#f53636',
                  confirmButtonText: 'OK'
                }).then(function() {
                  if(activarService){
                      window.location.href="/reportes/reporte-mt";
                  }
                })

            self.$loading.hide()

        });



      },


      async borrarSending(sendingsms) {

        let self = this;
         let user = (getUserSub()!=null) ? getUserSub() :getUser();

        let js = {
          "time_expired":horaAhora(),
          "customer":encodeURIComponent(JSON.stringify(user.customer)),
          "customer_user":encodeURIComponent(JSON.stringify(user)),
          "sending_sms":encodeURIComponent(JSON.stringify(sendingsms)),
          "application_id":1,
        }

        var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

        await Vue.axios.post(Config.url_service+Config.sending_sms_abort, body, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        })
          .then(function (response) {
              console.log(response)

              if (response.data.response === "200") {
                console.log(response.data.data);
              }else{

                self.checkEnvioProgramado = false;

                swal({
                  title: "Error borrado envio programado ",
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger btn-fill'
                })


              }

          })

      },

      getDraftByContactGroup(contactgroupId){


          var self = this;
            var draftId = "";
              this.previewDraft.forEach(function(key) {
                    if (key.contactGroup.contactGroupId == contactgroupId ||  key.master) {
                      draftId = key.draftId;
                      self.validForm.menssageContact = key.message
                    }
              });

          return draftId;
      },


      /**
       * Metodo de Envio individual
       */
      async envioServices(sending_sms,position){

        this.$loading.show()

        let self = this;


        if(!self.mostrarAlertEnvio){

          var msn=(self.radios.programacionEnvio=='unchecked') ? "programar" : "enviar";
              swal({
                  title: "¿Estás seguro de "+ msn +" esta campaña?",
                  text: 'Se van a utilizar '+self.totalCreditosUsar+' creditos de tu cuenta',
                  type: 'info',
                  buttonsStyling: false,
                  showCancelButton: true,
                  confirmButtonClass: 'btn btn-info',
                  cancelButtonClass: 'btn btn-danger',
                  confirmButtonText: "Si, "+msn,
                  closeOnConfirm: false,
                  closeOnCancel: false
                }).then(function(isconfirm) {

                  if(isconfirm.value){
                    self.mostrarAlertEnvio = true;
                    self.envioServices("",0);
                  }

                })

              this.$loading.hide()

              return false;

        }

        let user = await getUserRealTime();

        if(typeof this.$route.query.sending_sms!=="undefined"){

          await self.borrarSending(self.validForm.sendingsms)

        }

        if(self.radios.programacionEnvio=='unchecked'){
          var currentDate2 = new Date();
          currentDate2 = new Date(this.validForm.dateProgramgContact).getTime();
        }


        if(!self.checkEnvioProgramado){
          return false;
        }





      var currentDate = new Date();
      currentDate = new Date(currentDate).getTime();

      moment.locale('es');
      self.validForm.dateSend = (self.radios.programacionEnvio=='checked') ? moment(currentDate).format('LLL') : moment(currentDate2).format('LLL');

       self.validForm.sendingsms.calendar=(self.radios.programacionEnvio=='checked') ? currentDate:currentDate2;


        let js = {
        "time_expired":horaAhora(),
        "customer":encodeURIComponent(JSON.stringify(user.customer)),
        "sending_sms":encodeURIComponent(JSON.stringify((sending_sms!="") ? sending_sms : self.validForm.sendingsms)),
        "customer_user":encodeURIComponent(JSON.stringify(user)),
        "children_active":(self.contadorListImportadas >= 2) ? "false" : "false",
        "application_id":"1"
      }
      console.log("ENVIANDO SENDING SMS : ",(sending_sms!="") ? sending_sms : self.validForm.sendingsms)


      var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

     await Vue.axios.post(Config.url_service+Config.sending_sms_send, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      })
        .then(function (response) {
            console.log(response)

          if (response.data.response === "200" && ( response.data.data=="1"
            || response.data.data=="0") ) {

              if(self.contadorMultipleContactListCurrent >= 2){

                removeElement(self.contadorMultipleContactList,self.validForm.sendingsms.receiverId)
                console.log("self.contadorMultipleContactList ",self.contadorMultipleContactList)
                self.validForm.SendingSmsId=null;

                self.contadorMultipleContactList.forEach(async function(key) {
                    self.contadorMultipleContactListCurrent--;
                    position++;
                   await self.envioMasivo(key,true,position);
                });

                return false;

              }else{

               self.previewSend=[];

               self.validForm = {
                    estado:false,
                    field:"",
                    campaingName:"",
                    CodePhoneContact:getUser().customer.country.phoneCode,
                    PhoneContact:"",
                    listContact:"",
                    dateProgramgContact:"",
                    menssageContact:"",
                    selectDraft:[],
                    StepPreview:false,
                    dateSend:"",
                    sendingsms:"",
                    contacts:""
                }
                self.$loading.hide()


                swal({
                  title: (self.radios.programacionEnvio=='unchecked') ? "Campaña programada con exito" : "Campaña enviada con exito",
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-success',
                  type: 'success',
                }).then(function() {
                      window.location.href="/dashboard";
                })


              }

            }else if (response.data.data=="3") {

                swal({
                  title: "Error creditos insuficientes",
                  text: 'Ocurrio un error enviando la lista '+self.nameContactList+' Revisar en Reportes las campañas enviadas y reenviela nuevamente',
                  type: 'error',
                  showCancelButton: false,
                  confirmButtonColor: '#f53636',
                  confirmButtonText: 'OK'
                })
               self.$loading.hide()

            }else if (response.data.data=="2") {

                 swal({
                  title: "Error hora de envio invalido. Intente mas tarde",
                  text: 'Ocurrio un error enviando la lista '+self.nameContactList+' Revisar en Reportes las campañas enviadas y reenviela nuevamente',
                  type: 'error',
                  showCancelButton: false,
                  confirmButtonColor: '#f53636',
                  confirmButtonText: 'OK'
                })
               self.$loading.hide()

            } else {

                  swal({
                  title: "Error enviando mensaje ",
                  text: 'Ocurrio un error enviando la lista '+self.nameContactList+' Revisar en Reportes las campañas enviadas'
                    +' y reenviela nuevamente',
                  type: 'error',
                  showCancelButton: false,
                  confirmButtonColor: '#f53636',
                  confirmButtonText: 'OK'
                }).then(function() {
                      window.location.href="/reportes/reporte-mt";
                })

               self.$loading.hide()
              console.log("No se encontró sendservice");
            }


        })
        .catch(function (error) {

               swal({
                  title: "Error enviando mensaje ",
                  text: 'Ocurrio un error enviando la lista '+self.nameContactList+' Revisar en Reportes las campañas enviadas'
                    +' y reenviela nuevamente',
                  type: 'error',
                  showCancelButton: false,
                  confirmButtonColor: '#f53636',
                  confirmButtonText: 'OK'
                }).then(function() {
                      window.location.href="/reportes/reporte-mt";
                })

            self.$loading.hide()
            console.log("No se encontró sendservice",error);
        });



      },
      /**
     * Busca lista de contactos del grupo si es seleccionada
     */
      async getContactGroupPreview(currentIndexContactList,activarService){

              var self = this;



              var contactGroupId = "";
              this.selectOptionsListContact.forEach(function(key){

                  if(key.contactGroupId == (activarService) ? self.validForm.listContact[self.validForm.listContact.indexOf(currentIndexContactList)] :self.validForm.listContact[0]){
                    contactGroupId = key;
                  }

              })


              this.validForm.contacts = [];

                let js = {
                "time_expired":horaAhora(),
                "contact_group":encodeURIComponent(JSON.stringify(contactGroupId)),
                "contact_status":"true"
              }

              var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

              await Vue.axios.post(Config.url_service+Config.contact_available_contact_preview, body, {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              },
              })
                .then(function (response) {
                    console.log("PREVIEW",response)

                    if (response.data.response === "200") {


                      response.data.data.forEach(function(key){

                        self.validForm.contacts.push({
                            "sendingSmsDetailId":0,
                            "customerId":key.customerId,
                            "contactGroupId":self.validForm.listContact[0],
                            "name":self.validForm.campaingName,
                            "phoneCode":key.phoneCode,
                            "phone":key.phone,
                            "message":self.validForm.menssageContact ,
                            "operatorId":0,
                            "blacklistUser":false,
                            "udh":true
                          });

                      })


                    } else {
                      console.log("No se encontró lista de contactos");
                      swal({
                          title: "Error procesando lista de contactos",
                          buttonsStyling: false,
                          confirmButtonClass: 'btn btn-danger btn-fill'
                        })
                    }

                })
                .catch(function (error) {
                    console.log("No se encontró lista de contactos",error);
                });

      },



      /**
     * Busca lista de contactos del grupo si es seleccionada
     */
      async getUdhCredits(currentIndexContactList,activarService,currentDate,currentDate2){

              var self = this;

               let user = (getUserSub()!=null) ? getUserSub() :getUser();

              let sumTotal = 0;

              var sending_array=[];


           self.listAnidadas.forEach(function(key) {

               var senActual  = {
                    "customerId":user.customer.customerId,
                    "sendingSmsId":self.validForm.SendingSmsId,
                    "name": (typeof self.$route.query.sending_sms!=="undefined") ? self.validForm.campaingName : self.validForm.campaingName+" "+self.nameContactList,
                    "receiverType":2,
                    "receiverId":self.validForm.listContact[self.validForm.listContact.indexOf(key.id)],
                    "phoneCode":self.validForm.CodePhoneContact,
                    "phone":0,
                    "draftId":self.getDraftByContactGroup((activarService) ? self.validForm.listContact[self.validForm.listContact.indexOf(key.id)] :key.id) ,
                    "messageType":(self.radios.redactar=='checked') ? 1 : 2,
                    "message":self.validForm.menssageContact ,
                    "calendarType":(self.radios.programacionEnvio=='checked') ? 1 : 2,
                    "calendar":(self.radios.programacionEnvio=='checked') ? currentDate:currentDate2,
                    "createdby":user.customerUserId,
                    "created":currentDate,
                    "aborted":false,
                    "sendingSmsDetailList":(self.validForm.contacts.length >= 10) ? self.validForm.contacts.slice(0,9) : self.validForm.contacts,
                    "sendingStatus":(typeof self.$route.query.sending_sms!=="undefined") ? "0":"1",
                    "sendingTotal":self.validForm.sendingTotal,
                  }


              console.log(senActual.receiverId+" SENDING ARRAY ",senActual)

              sending_array.push(senActual)
              senActual="";

          })


              let js = {
                "time_expired":horaAhora(),
                "customer":encodeURIComponent(JSON.stringify(user.customer)),
                "sending_sms":encodeURIComponent(JSON.stringify(sending_array)),
              }

              var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

              await Vue.axios.post(Config.url_service+Config.udh_validate_credits, body, {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              },
              })
                .then(function (response) {
                    console.log(response)

                    if (response.data.response == "200") {

                      self.validForm.sendingUDH = response.data.data;

                    } else {
                      sumTotal=0;
                      swal({
                          title: "Error procesando UDH",
                          buttonsStyling: false,
                          confirmButtonClass: 'btn btn-danger btn-fill'
                        })
                    }

                })
                .catch(function (error) {
                  sumTotal=0;
                    console.log("Error procesando UDH",error);
                });

      },




      getTotalSendingUdh(receiverId){

        var total=0;
        var sum=0;

        var self = this;

        self.validForm.sendingUDH.forEach(function(key) {
          sum+=key.sendingTotal;
          if(key.receiverId==receiverId){
            total = key.sendingTotal;
          }
        })

        self.totalCreditosUsar = sum;

        return total;

      },


       /**
       * CARGAR INFORMACION DEL SENDING PARA EDITAR Y REENVIAR
       */
     getSending(){

       if(typeof this.$route.query.sending_sms!=="undefined"){


      let self = this;
       let user = (getUserSub()!=null) ? getUserSub() :getUser();

      let js = {
        "time_expired":horaAhora(),
        "sending_sms":this.$route.query.sending_sms,
        "customer":encodeURIComponent(JSON.stringify(user.customer))
      }

      var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

     Vue.axios.post(Config.url_service+Config.sending_sms_get, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      })
        .then(function (response) {

            if (response.data.response === "200") {

              self.sendingInfoEdit = response.data.data;

              self.validForm.SendingSmsId = response.data.data.sendingSmsId;
              self.validForm.campaingName = response.data.data.name;
              self.validForm.CodePhoneContact = response.data.data.phoneCode;
              self.validForm.PhoneContact = response.data.data.phone;
              self.validForm.menssageContact = response.data.data.message;

              if(response.data.data.receiverId!=null && response.data.data.receiverId!=0 && response.data.data.receiverId!=""){
                //self.validForm.listContact=[];
                self.validForm.listContact.push(response.data.data.receiverId);
                self.radios.radio1='unchecked';
              }

            if(response.data.data.draftId!=null && response.data.data.draftId!=0 && response.data.data.draftId!=""){
                //self.validForm.selectDraft=[]
                self.radios.redactar='unchecked';
                self.previewDraft = [];
                self.validForm.selectDraft[0]=response.data.data.draftId;

                //BUSCA NOMBRE DE DRAFT SELECCIONADA
                self.selectOptionsListDraft.forEach(function(key) {
                    if (key.draftId == response.data.data.draftId) {
                      self.previewDraft.push(key);
                    }
              });


              }


              if(response.data.data.calendarType==1){

                self.radios.programacionEnvio='checked'

              }else{

                self.radios.programacionEnvio='unchecked'

              }

             self.validForm.dateSend = moment(response.data.data.calendar).format('YYYY-MM-DD HH:mm:ss')
             self.validForm.dateProgramgContact = moment(response.data.data.calendar).format('YYYY-MM-DD HH:mm:ss')


            } else {

              swal({
                title: "Error no se pudo carga la informacion del envio",
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger btn-fill'
              })

            }


        })
        .catch(function (error) {
          console.log(error)
            swal({
                title: "Error no se pudo carga la informacion del envio",
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger btn-fill'
              })
        });
       }

      },

     loadView(){



       if( getUser().customer.rut!=null || getUser().customer.adress!=null  ){

        this.loadGroupContact();
        this.loadDraft();
        this.loadLanding();

       }else{

          swal({
                title: "Complete los datos de usuario.",
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger btn-fill'
              }).then(function() {
              window.location.href="/cuenta/perfil";
               })


       }

      },
      showDropzone() {
        return this.radios.radio1=='unchecked' && this.checkImportList==true;
      },
      numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },

    created(){

      this.loadView();

    },
    mounted(){

      if(typeof this.$route.query.sending_sms!=="undefined"){
        var self = this;
        swal({
          title: "Estás editando un envio programado",
          type: 'info',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-info',
          timer: 3000,
        }).then(function() {
              self.getSending();
        })

      }

    }
  }
</script>
